import React from 'react';
import { Icon } from '@livable/saas-react-components';
import { Button, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { BasicTooltip } from '@livable/saas-react-components';
import TransactionMenu from '../TransactionMenu';
import MonthlySummary from '../MonthlySummary';
import useStyles from './styles';
export default function TransactionsTable() {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.transactionsTable
  }, /*#__PURE__*/React.createElement(MonthlySummary, null), /*#__PURE__*/React.createElement(TableContainer, null, /*#__PURE__*/React.createElement(Table, {
    "aria-label": "transactions table",
    type: "compactMobile"
  }, /*#__PURE__*/React.createElement(TableBody, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, {
    className: classes.mediumCell
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.transactionTime
  }, "12/05/2021 10:00 AM")), /*#__PURE__*/React.createElement(TableCell, {
    className: classes.mediumCell
  }, "Utility charge", /*#__PURE__*/React.createElement("span", {
    className: classes.showTablet
  }, ": Water")), /*#__PURE__*/React.createElement(TableCell, {
    className: "".concat(classes.hideTablet, " ").concat(classes.smallCell)
  }, "Water"), /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("div", {
    className: classes.periodCell
  }, "Service period: MM/DD/YYYY-MM/DD/YYYY")), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: classes.summaryCell
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: "Memo here",
    placement: "top"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    'custom-attribute': '784-reporting-page-transaction-table'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "memo"
  }))), /*#__PURE__*/React.createElement(BasicTooltip, {
    title: "Note here",
    placement: "top",
    'custom-attribute': '785-reporting-page-transaction-table'
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "note"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.summary
  }, /*#__PURE__*/React.createElement(Icon, {
    state: "dark",
    type: "minus"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.transactionAmount
  }, "$XX.XX"))), /*#__PURE__*/React.createElement(TableCell, {
    align: "right",
    className: classes.xsmallCell
  }, /*#__PURE__*/React.createElement(TransactionMenu, null)))))));
}